export function padSectionNumber(num) {
  return num.toString().padStart(2, '0');
}

export function slugifySectionName(name) {
  return name
    .toLowerCase()
    .replace(/–/g, '-') 
    .replace(/—/g, '-') 
    .replace(/&/g, 'and')
    .replace(/[^a-z0-9\s-]/g, '') 
    .replace(/\s+/g, '-') 
    .replace(/-+/g, '-') 
    .replace(/^-+|-+$/g, ''); 
}